import { UAParser } from 'ua-parser-js';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const USER_AGENT = new UAParser().getResult();

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum EDeviceOrientation {
  landscape,
  portrait,
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum EDeviceEnvironment {
  browser = 'browser',
  mobile = 'mobile',
}

export enum MobileFeatures {
  canResolveStepConflicts = 'CAN_RESOLVE_STEP_CONFLICTS',
  hasNativeVideo = 'HAS_NATIVE_VIDEO',
  multiplatform = 'MULTIPLATFORM',
}

export enum MobileAppPlatform {
  android = 'Android',
  ios = 'iOS',
}

export const IS_MOBILE_TOKEN = new InjectionToken<Observable<boolean>>('shared/device/IS_MOBILE');

export const DEFAULT_MODIFICATOR_IF_MOBILE = '-mobile';
